/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Transforms JSON rows from string JSON to JavaScript Object
 */
/**
 * Transforms JSON rows from string JSON to JavaScript Object
 */
const transformJSONRows = (responseData: any) => {
  if (responseData && responseData.data && Array.isArray(responseData.data)) {
    responseData.data.forEach((row: any) => {
      const keys = Object.keys(row);
      keys.forEach((key) => {
        if (typeof row[key] === "string" && row[key].indexOf("{") === 0) {
          try {
            row[key] = JSON.parse(row[key]);
          } catch (e) {
            // eslint-ignore
          }
        }
      });
    });
  }
  return responseData;
};
export default transformJSONRows;
